import fetch from "../components/optionsFetch";
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormInput, FormDropDownList } from "../components/formComponents";
import { Button } from "@progress/kendo-react-buttons";
import { GetPermissions } from '../components/Options';
import { GetUserId } from '../components/Session';
import '../StyleSheet.css';


const Account = () => {
    const id = GetUserId();
    const [formkey, setFormkey] = React.useState(0);
    const [states, setStates] = React.useState([]);
    const [permissions, setPermissions] = React.useState(null);
    const navigate = useNavigate();
    const [message, setMessage] = React.useState("");
    if (permissions && !permissions.CanView) navigate("/");
    if (localStorage.getItem("userid") === null) navigate("/logout");

    const [layout, setLayout] = React.useState([
        { "field": "password", "label": "Password", "defaultValue": "", "isVisible": true, "type": "password" },
        { "field": "fullName", "label": "Full Name", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "address1", "label": "Address 1", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "address2", "label": "Address 2", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "suburb", "label": "Suburb", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "state", "label": "State", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "postcode", "label": "Postcode", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "phone", "label": "Phone", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "mobile", "label": "Mobile", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "email", "label": "Email", "defaultValue": "", "isVisible": true, "type": "text" }
    ]);

    const GetField = (f) => layout.find(obj => obj.field === f);

    const [values, setValues] = React.useState({
        roleId: 0,
        password: GetField("password")?.defaultValue || "",
        fullName: GetField("fullName")?.defaultValue || "",
        address1: GetField("address1")?.defaultValue || "",
        address2: GetField("address2")?.defaultValue || "",
        suburb: GetField("suburb")?.defaultValue || "",
        state: GetField("state")?.defaultValue || "",
        postcode: GetField("postcode")?.defaultValue || "",
        phone: GetField("phone")?.defaultValue || "",
        mobile: GetField("mobile")?.defaultValue || "",
        email: GetField("email")?.defaultValue || ""
    });

    React.useEffect(() => {
        GetPermissions(["ViewAccount"], setPermissions);

        const headers = { "Authorization": "Bearer " + GetToken() };

        fetch(`${configData.SERVER_URL}apiv7/userinterfaces?$filter=viewName eq 'Account'`, { headers })
            .then(res => res.json())
            .then(d => {
                if (GetSession().IsMobile) {
                    const data = d.map(item => ({
                        field: item.field,
                        label: item.label,
                        type: item.type,
                        format: item.format,
                        isVisible: item.isVisible && item.isVisibleOnMobile
                    }));
                    setLayout(data);
                } else {
                    setLayout(d);
                }
            });

        fetch(`${configData.SERVER_URL}apiv7/options`, { headers })
            .then(res => res.json())
            .then(opt => {
                setStates(opt.states);
                if (id !== undefined) {
                    fetch(`${configData.SERVER_URL}apiv7/users/${id}`, { headers })
                        .then(res => res.json())
                        .then(d => {
                            const role = opt.roles.find(r => r.id === String(d.roleId));
                            setValues({
                                roleId: d.roleId === null ? "" : role,
                                name: d.name || "",
                                password: d.password || "",
                                fullName: d.fullName || "",
                                position: d.position || "",
                                description: d.description || "",
                                address1: d.address1 || "",
                                address2: d.address2 || "",
                                suburb: d.suburb || "",
                                state: d.state || "",
                                postcode: d.postcode || "",
                                phone: d.phone || "",
                                mobile: d.mobile || "",
                                email: d.email || "",
                                country: d.country || "",
                                addressDetails: d.addressDetails || "",
                                siteDetails: d.siteDetails || "",
                                userSites: d.siteList,
                                active: d.isActive || ""
                            });
                            setFormkey(fk => fk + 1);
                        });
                }
            });
    }, []);

    const GetDefaultData = (f, name) => {
        let fld = GetField(name);
        if (!fld) return f;
        if (fld.isVisible) return f;
        switch (fld.type) {
            case "text": return fld.defaultValue || "";
            case "numeric": return parseFloat(fld.defaultValue) || 0;
            case "boolean": return fld.defaultValue === "true";
            default: return fld.defaultValue || "";
        }
    }

    const handleSubmit = (dataItem) => {
        const pth = id === undefined ? "" : "/" + id;
        const url = `${configData.SERVER_URL}apiv7/users${pth}`;
        const init = {
            method: id === undefined ? 'POST' : 'PUT',
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                userId: id,
                roleId: GetDefaultData(dataItem.roleId?.id, "roleId"),
                name: GetDefaultData(dataItem.name, "name"),
                password: GetDefaultData(dataItem.password, "password"),
                fullName: GetDefaultData(dataItem.fullName, "fullName"),
                position: GetDefaultData(dataItem.position, "position"),
                description: GetDefaultData(dataItem.description, "description"),
                address1: GetDefaultData(dataItem.address1, "address1"),
                address2: GetDefaultData(dataItem.address2, "address2"),
                suburb: GetDefaultData(dataItem.suburb, "suburb"),
                state: GetDefaultData(dataItem.state, "state"),
                postcode: GetDefaultData(dataItem.postcode, "postcode"),
                phone: GetDefaultData(dataItem.phone, "phone"),
                mobile: GetDefaultData(dataItem.mobile, "mobile"),
                email: GetDefaultData(dataItem.email, "email"),
                country: GetDefaultData(dataItem.country, "country"),
                addressDetails: GetDefaultData(dataItem.addressDetails, "addressDetails"),
                siteDetails: GetDefaultData(dataItem.siteDetails, "siteDetails"),
                siteList: dataItem.userSites,
                isActive: GetDefaultData(dataItem.active, "active"),
            })
        };
        fetch(url, init)
            .then(() => Redirect("Operator updated"));
    };

    const DisplayMessage = (m) => {
        setMessage(m);
        setTimeout(() => setMessage(""), 3000);
    };

    const clearFilters = () => {
        const userId = GetSession().UserId;
        const url = `${configData.SERVER_URL}apiv7/private/deleteuserfilters?userid=${userId}`;
        const init = {
            method: 'DELETE',
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        };
        fetch(url, init)
            .then(() => DisplayMessage("Filters cleared"));
    };

    const Redirect = (msg = "") => {
        navigate("/transactions", { state: { msg } });
    };

    const textValidator = (value) => !value ? "Please enter a value" : "";

    return (
        <>

            <div className="background-3d" />
            <div className="form-wrapper">
                <h2>Account Details</h2>
                {message && (
                    <div style={{ textAlign: 'center', marginBottom: '1rem', color: 'green', fontWeight: '600' }}>
                        {message}
                    </div>
                )}

                <Form onSubmit={handleSubmit} initialValues={values} key={formkey} render={formRenderProps => (
                    <FormElement>
                        <fieldset className="k-form-fieldset">
                            <div className="row">
                                {GetField("fullName")?.isVisible && <div className="col-md-3">
                                    <Field id="fullName" name="name" label={GetField("fullName").label} disabled={true} component={FormInput} />
                                </div>}
                                {GetField("password")?.isVisible && <div className="col-md-3">
                                    <Field id="password" name="password" label={GetField("password").label} type="password" disabled={true} component={FormInput} validator={textValidator} />
                                </div>}
                            </div>
                            <div className="row">
                                {GetField("address1")?.isVisible && <div className="col-md-3">
                                    <Field id="address1" name="address1" label={GetField("address1").label} component={FormInput} />
                                </div>}
                                {GetField("address2")?.isVisible && <div className="col-md-3">
                                    <Field id="address2" name="address2" label={GetField("address2").label} component={FormInput} />
                                </div>}
                            </div>
                            <div className="row">
                                {GetField("suburb")?.isVisible && <div className="col-md-3">
                                    <Field id="suburb" name="suburb" label={GetField("suburb").label} component={FormInput} />
                                </div>}
                                {GetField("state")?.isVisible && <div className="col-md-3">
                                    <Field id="state" name="state" label={GetField("state").label} component={FormDropDownList} data={states} />
                                </div>}
                                {GetField("postcode")?.isVisible && <div className="col-md-3">
                                    <Field id="postcode" name="postcode" label={GetField("postcode").label} component={FormInput} />
                                </div>}
                            </div>
                            <div className="row" style={{ alignItems: 'center' }}>
                                {GetField("phone")?.isVisible && <div className="col-md-3">
                                    <Field id="phone" name="phone" label={GetField("phone").label} component={FormInput} />
                                </div>}
                                {GetField("mobile")?.isVisible && <div className="col-md-3">
                                    <Field id="mobile" name="mobile" label={GetField("mobile").label} component={FormInput} />
                                </div>}
                                {GetField("email")?.isVisible && <div className="col-md-3">
                                    <Field id="email" name="email" label={GetField("email").label} component={FormInput} />
                                </div>}
                                <div className="col-md-3" style={{ paddingTop: 40 }}>
                                    <Button
                                        className="k-button"
                                        onClick={clearFilters}
                                        type="button"
                                    >
                                        Clear user filter
                                    </Button>
                                </div>
                            </div>
                        </fieldset>

                        <div className="buttons-row">
                            <Button
                                type="submit"
                                themeColor="primary"
                                className="k-button"
                                disabled={!formRenderProps.allowSubmit}
                            >
                                Save
                            </Button>
                        </div>
                    </FormElement>
                )} />
            </div>
        </>
    );
}

export default Account;
